"use strict";
class InViewInfo {
    constructor() {
        this.inView = false;
        this.changed = false;
    }
}
exports.InViewInfo = InViewInfo;
